import _typeof from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "fu-single"
};
var _hoisted_2 = {
  key: 0,
  class: "center"
};
var _hoisted_3 = {
  class: "fu-single-tab"
};
var _hoisted_4 = {
  class: "fu-single-content"
};
var _hoisted_5 = {
  key: 2,
  class: "center"
};
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { routeAuth } from '@/utils/auth';
import FilePreviewDialog from '@/components/FilePreview/FilePreviewDialog';
import SubTab from '../../Components/SubTab.vue';
import Message from './Message.vue';
import Contact from './Contact.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var tabs = [{
      name: '问答消息',
      value: 1,
      component: Message,
      exist: true
    }, {
      name: '班级通讯录',
      value: 2,
      component: Contact,
      exist: true
    }];
    var loading = ref(true);
    var hasAuth = ref(false);
    var defaultIndex = ref(1);
    var visible = ref(false);
    var newUrl = ref('');
    var fileName = ref('');
    var cancatInfo = ref({});
    var isConcat = ref(false);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      console.log(item, 41);
      defaultIndex.value = item.value;
      isConcat.value = false;
      cancatInfo.value = {};
    };
    var handleRouteAuth = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var auth, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return routeAuth('chatQa');
            case 1:
              auth = _context.v;
              hasAuth.value = auth;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Failed to get route auth:', _t);
              hasAuth.value = false;
            case 3:
              _context.p = 3;
              loading.value = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function handleRouteAuth() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleMessage = function handleMessage(msg) {
      var data = msg.data;
      // console.log(data, msg, 50)

      if (typeof data !== 'string' && _typeof(data) !== 'object') {
        console.warn('Invalid message data type:', data);
        return;
      }
      var ParseData = _typeof(data) === 'object' ? data : JSON.parse(data);
      if (ParseData.type === 'filePreview') {
        fileName.value = ParseData.fileName;
        newUrl.value = ParseData.data;
        visible.value = true;
      } else if (ParseData.type === 'openChat') {
        defaultIndex.value = 1;
        isConcat.value = true;
        cancatInfo.value = ParseData.data.info;
      }
    };
    onMounted(function () {
      handleRouteAuth();
      window.addEventListener('message', handleMessage);
    });
    onUnmounted(function () {
      window.removeEventListener('message', handleMessage);
    });
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading)])) : _createCommentVNode("", true), !loading.value && hasAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_3, [_createVNode(SubTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), {
        cancatInfo: cancatInfo.value,
        isConcat: isConcat.value
      }, null, 8, ["cancatInfo", "isConcat"]))])], 64)) : _createCommentVNode("", true), !loading.value && !hasAuth.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_Empty, {
        text: "暂无应用权限"
      })])) : _createCommentVNode("", true), _createVNode(_unref(FilePreviewDialog), {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        fileName: fileName.value,
        path: newUrl.value
      }, null, 8, ["visible", "fileName", "path"])]);
    };
  }
};